import { orderBy } from "lodash";
import { BenefitType } from "../common/interfaces/enums/BenefitType";
import { DiscountType } from "../common/interfaces/enums/DiscountType";
import { Gender } from "../common/interfaces/enums/Gender";
import { PaymentFrequency } from "../common/interfaces/enums/PaymentFrequency";
import { PremiumStructure } from "../common/interfaces/enums/PremiumStructure";
import ProductType from "../common/interfaces/enums/ProductType";
import { SmokerStatus } from "../common/interfaces/enums/SmokerStatus";
import SortBy from "../compare/enums/SortBy";
import { SpecialOffer } from "../compare/enums/SpecialOffer";
import { IClient } from "../common/interfaces/IClient";
import IQuoteCardProduct from "../compare/interfaces/results/IQuoteCardProduct";
import IQuoteCardResult from "../compare/interfaces/results/IQuoteCardResult";
import { IQuoteSettingContainerLife } from "../common/interfaces/settings/IQuoteSettingContainerLife";

/**
 *
 *  This file is filled with sample data to test with.
 *
 */

const sampleSettingsData: IQuoteSettingContainerLife = {
    addons: [{
        id: 1,
        systemName: "AIAVitality",
        providerId: 3,
        addOnName: "AIA Vitality",
        isSelectedByDefault: false
    }],
    allowChildren: false,
    caseId: 3667846,
    clients: [
        {
            isSelected: true,
            personId: 5226330,
            coverAmount: 500000,
            premiumStructure: PremiumStructure.Stepped
        }
    ],
    isLatestVersion: true,
    paymentFrequency: PaymentFrequency.Fortnightly,
    productType: ProductType.Life,
    sortBy: SortBy.LowestPrice,
    versionId: 2,
    premiumStructure: PremiumStructure.Stepped
};

const sampleClientData: IClient[] = [
    {
        age: 35,
        isActive: true,
        isChild: false,
        gender: Gender.Male,
        personId: 5226330,
        smokerStatus: SmokerStatus.NonSmoker
    }
];

const sampleProductResultData: IQuoteCardProduct = {
    documents: {
        brochure: {
            documentUrl:
                "https://dev.lifedirect.co.nz/filesdisplay.aspx?type=docsrep&fileid=2026",
            thumbnailUrl:
                "https://dev.lifedirect.co.nz/filesdisplay.aspx?type=docsrep_thumb46&fileid=2026"
        },
        policy: {
            documentUrl:
                "https://dev.lifedirect.co.nz/filesdisplay.aspx?type=docsrep&fileid=2027",
            thumbnailUrl:
                "https://dev.lifedirect.co.nz/filesdisplay.aspx?type=docsrep_thumb46&fileid=2027"
        }
    },
    policyFeatures: [
        {
            sectionId: 2,

            detail: "[Tick]",
            detailMore: "",
            detailShowMore: "",

            orderBy: 3,
            sectionName: "Full payment on terminal illness",
            tooltip: "The insurer pays your full insured amount on terminal illness.",

            isDifference: true
        },
        {
            sectionId: 3,

            detail: "Only one",
            detailMore: "(suicide within 13 months)",
            detailShowMore: "",

            orderBy: 4,
            sectionName: "Exclusion",
            tooltip: "What cause(s) of death does the insurer not cover?",

            isDifference: true
        },
        {
            sectionId: 4,

            detail: "[Tick]",
            detailMore: "$15,000",
            detailShowMore: "",

            orderBy: 5,
            sectionName: "Funeral grant",
            tooltip: "How much is the immediate payment to help with funeral expenses?",

            isDifference: true
        },
        {
            sectionId: 69,

            detail: "[Tick]",
            detailMore: "",
            detailShowMore: "",

            orderBy: 6,
            sectionName: "Worldwide cover",
            tooltip: "Does the policy offer 24 hour, worldwide protection?",

            isDifference: false
        },
        {
            sectionId: 5,

            detail: "[Tick]",
            detailMore: "",
            detailShowMore:
                "Marriage or civil union, divorce or dissolve a registered civil union, death of your spouse or partner, birth or adoption of a child, take out or increase a loan (of at least $25,000) ecured over your primary residence, a new residential investment property, a holiday home, or a bare block of land zoned as residential, annual salary increases by at least $5,000, becoming a carer for the first time, financially supporting a dependent child starting private secondary school or a first course of fulltime tertiary education, Every 5th anniversary of the commencement date. Conditions apply.",

            orderBy: 7,
            sectionName: "Easy increase",
            tooltip:
                "You can increase your cover, without providing new health information, if you experience certain life events (like having a baby). Conditions apply.",

            isDifference: true
        },
        {
            sectionId: 6,

            detail: "[Tick]",
            detailMore: "",
            detailShowMore: "",

            orderBy: 8,
            sectionName: "Inflation adjusted",
            tooltip:
                "You can choose to have your insured amount increase annually with inflation.",

            isDifference: false
        },
        {
            sectionId: 8,
            detail: "[Tick]",
            detailMore: "60 days, $550,000 max",
            detailShowMore: "",

            orderBy: 9,
            sectionName: "Cover during application",
            tooltip:
                "Insurers offer basic, temporary cover while they assess your application. Note: this cover has limitations and is not available to all people.",

            isDifference: true
        },
        {
            sectionId: 9,

            detail: "[Tick]",
            detailMore: "$2,500",
            detailShowMore: "",

            orderBy: 10,
            sectionName: "Financial planning grant",
            tooltip:
                "If a claim is made, the insurer will pay an additional amount to help with the cost of financial advice.",

            isDifference: true
        },
        {
            sectionId: 10,
            detail: "[Tick]",
            detailMore: "",
            detailShowMore: "",
            orderBy: 11,
            sectionName: "Policy wording upgrade",
            tooltip:
                "The insurer guarantees to 'pass back' any enhancements or additions made to future versions of their policy.",
            isDifference: true
        }
    ],
    productId: 0,
    productName: "Test Product Name",
    sellingPoints: []
};

const sampleResultData: IQuoteCardResult[] = [
    {
        cardKey: 1,
        applicationSource: 1,   // Legacy internal appform
        ratings: {
            customerService: {
                ratingInfo: 4.4019337016574589,
                orderBy: 4.4019337016574589,
                title: "Customer Service"
            },
            financialStrength: {
                orderBy: 9.34,
                title: "",
                ratingInfo: {
                    rating: "AA-",
                    ratingAgency: "S & P",
                    ratingDescription: "Strong",
                    ratingOrder: 6
                }
            },
            providerPopularity: {
                orderBy: 45,
                title: "Provider Popularity",
                ratingInfo: 45
            },
            provider: {
                orderBy: 0,
                title: "",
                ratingInfo: {
                    productRatings: [
                        {
                            productId: 4,
                            percentRating: 1.0,
                            productType: ProductType.Life,
                            starRating: 5.0
                        }
                    ],
                    providerId: 4,
                    totalStarRating: 5.0,
                    totalPercentRating: 1.0,
                    sortByRating: 1.0
                }
            },
            premium: {
                orderBy: 1,
                title: "",
                ratingInfo: 1
            }
        },
        state: {
            isFavourited: false,
            hasMultiBenefitDiscountOffer: false,
            hasMultiBenefitDiscountApplied: false,
            isHighlighted: true,
            isOverMinimumPremium: true,
            isSelected: false,
            hasBlockingError: false
        },
        totalCashback: 68.28,
        result: {
            providerId: 4,
            providerName: "Fidelity",
            paymentFrequency: PaymentFrequency.Monthly,
            clients: [
                {
                    personId: 5513789,
                    age: 35,
                    gender: Gender.Female,
                    smokerStatus: SmokerStatus.Smoker,
                    isChild: false,
                    isActive: true
                }
            ],
            settings: [
                {
                    productType: ProductType.Life,
                    addons: [],
                    allowChildren: false,
                    caseId: 3667846,
                    clients: [
                        {
                            personId: 5513789,
                            coverAmount: 500000,
                            isSelected: true,
                            premiumStructure: PremiumStructure.Stepped
                        }
                    ],
                    isLatestVersion: true,
                    paymentFrequency: PaymentFrequency.Fortnightly,
                    premiumStructure: PremiumStructure.Stepped,
                    sortBy: SortBy.LowestPrice,
                    versionId: 0
                }
            ],
            benefits: [
                {
                    caseId: 3667846,
                    // quoteProductId: 20,
                    productId: 20,
                    personId: 5513789,
                    benefitType: BenefitType.LifeCover,
                    premium: 13.13,
                    coverAmount: 500000.0,
                    excess: 500000,
                    discountedPremium: 8.13,
                    discounts: [
                        {
                            percentage: 0.1,
                            type: DiscountType.MultiPolicy,
                            value: 5
                        }
                    ]
                }
            ],
            premium: 13.13,
            policyFee: 0.0,
            policyFeeDiscount: 0.0,
            totalDiscount: 5.0,
            totalPremium: 13.13,
            errors: [],
            collectionID: 0,
            selectedAddOns: []
        },
        specialOffers: [
            {
                specialOfferName: SpecialOffer.CashBack20,
            },
            {
                specialOfferName: SpecialOffer.AsteronBestDoctors,
            }
        ],
        productInfo: {
            [ProductType.Life]: sampleProductResultData,
            [ProductType.Trauma]: sampleProductResultData
        },
        providerAddons: []
    }
];

export default {
    sampleClientData,
    sampleSettingsData,
    sampleResultData
};
